import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ScrollToTop from "../../components/ScrollToTop";
import "./events.css";

/** Generic NSD chrome shared by every page in the events subtree. */
const EventShell = ({ children }) => (
  <div className="App events-app">
    <Header variant="events" />
    <main>
      <ScrollToTop />
      {children}
    </main>
    <Footer />
  </div>
);

export default EventShell;
